import * as React from 'react'

import { ExistingDelegationModel } from 'app/models/existingDelegationModel'

import { useScene } from '../context/SceneContext'
import { BOTTOM_PADDING } from '../utils/layout'

export type ExistingDelegationBlockProps = {
  existingDelegation: ExistingDelegationModel
  index: number
}

const prepareTooltipInfo = (
  existingDelegation: ExistingDelegationModel,
): ExistingDelegationModel => {
  const info: ExistingDelegationModel = {
    startTime: existingDelegation.startTime,
    endTime: existingDelegation.endTime,
    delegationId: existingDelegation.delegationId,
    delegationNumber: existingDelegation.delegationNumber,
    destinationCountryName: existingDelegation.destinationCountryName,
  }
  return info
}


export const ExistingDelegationBlock: React.FC<ExistingDelegationBlockProps> =
  React.memo((props: ExistingDelegationBlockProps) => {
    const scene = useScene()

    const existingDelegation = props.existingDelegation
    const HEIGHT = scene.height - 28

    const width = scene.widthOf(
      existingDelegation.startTime,
      existingDelegation.endTime,
    )
    const left = scene.timeToX(existingDelegation.startTime)

    return (
      <div
        className="tw-flex tw-flex-col tw-items-start tw-justify-end"
        style={{
          left,
          position: 'absolute',
          top: 0,
          bottom: 0,
          paddingBottom: BOTTOM_PADDING,
        }}
      >
        <div
          data-tip={JSON.stringify(prepareTooltipInfo(existingDelegation))}
          data-for="existingDelegationItemTooltip"
          style={{
            background: '#6B77A0',
            height: HEIGHT,
            width: width,
            opacity: 0.5,
            pointerEvents: 'auto',
          }}
        />
      </div>
    )
  })

ExistingDelegationBlock.displayName = 'ExistingDelegationBlock'
